import script from "./ReviewForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewForm.vue?vue&type=script&setup=true&lang=js"

import "./ReviewForm.vue?vue&type=style&index=0&id=3eb91b02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb91b02"]])

export default __exports__